<template>
  <div id="CustomerDetail" v-if="customerDetail">
    <!-- Header Card DAH INFO + PCRF INFO. -->
    <div class="tile is-ancestor">
      <!-- DAH INFO. -->
      <div class="tile is-parent" style="text-align: left;">
        <div class="tile is-child box" style="padding-top: 2rem;">
          <div class="columns">
            <div class="column is-12">
              <p class="title" style="color: #00AEEF;">
                {{ $t("customer.detail.msisdn") }}
                {{ customerDetail.customer.msisdn }}
              </p>

              <p class="subtitle is-6" style="margin-bottom: 0.5rem;">
                {{ $t("customer.detail.created_date") }}:
                {{ customerDetail.customer.created.time | dateformatter }} by
                {{ customerDetail.customer.created.email }}
              </p>

              <!-- Grouped Tags -->
              <b-field grouped group-multiline>
                <!-- SMS Language  -->
                <div v-if="customerDetail.customer.sms_lang" class="control">
                  <b-taglist attached>
                    <b-tag>{{ $t("customer.detail.sms_lang") }}</b-tag>
                    <b-tag type="is-info">{{
                      customerDetail.customer.sms_lang | uppercased
                    }}</b-tag>
                  </b-taglist>
                </div>

                <!-- Telp Type -->
                <div v-if="customerDetail.customer.telp_type" class="control">
                  <b-taglist attached>
                    <b-tag>{{ $t("customer.detail.telp_type") }}</b-tag>
                    <b-tag
                      v-if="customerDetail.customer.telp_type === 'T'"
                      type="is-info"
                      >Postpaid</b-tag
                    >
                    <b-tag v-else type="is-pink">
                      <p v-if="customerDetail.customer.telp_type === 'P'">
                        Prepaid
                      </p>
                      <p v-else>{{ customerDetail.customer.telp_type }}</p>
                    </b-tag>
                  </b-taglist>
                </div>

                <!-- DAH Status -->
                <div v-if="customerDetail.customer.status" class="control">
                  <b-taglist attached>
                    <b-tag>{{ $t("customer.detail.customer_status") }}</b-tag>
                    <b-tag
                      v-if="customerDetail.customer.status === 'active'"
                      type="is-success"
                      >{{ customerDetail.customer.status | capitalized }}</b-tag
                    >
                    <b-tag
                      v-else-if="customerDetail.customer.status === 'closed'"
                      type="is-danger"
                      >{{ customerDetail.customer.status | capitalized }}</b-tag
                    >
                    <b-tag v-else type="is-warning">{{
                      customerDetail.customer.status | capitalized
                    }}</b-tag>
                  </b-taglist>
                </div>

                <!-- PCRF Status -->
                <div v-if="customerDetail.customer.pcrf_status" class="control">
                  <b-taglist attached>
                    <b-tag>{{ $t("customer.detail.pcrf_status") }}</b-tag>
                    <b-tag
                      v-if="customerDetail.customer.pcrf_status === 'in_area'"
                      type="is-success"
                      >{{
                        customerDetail.customer.pcrf_status | capitalized
                      }}</b-tag
                    >
                    <b-tag
                      v-else-if="
                        customerDetail.customer.pcrf_status === 'out_area'
                      "
                      type="is-danger"
                      >{{
                        customerDetail.customer.pcrf_status | capitalized
                      }}</b-tag
                    >
                    <b-tag v-else type="is-warning">{{
                      customerDetail.customer.pcrf_status | capitalized
                    }}</b-tag>

                    <!-- <b-tag
                      :type="customerDetail.customer.pcrf_status === 'in_area'? 'is-success' : 'is-danger'"
                    >{{customerDetail.customer.pcrf_status}}</b-tag>-->
                  </b-taglist>
                </div>
              </b-field>
            </div>
          </div>

          <div class="columns is-multiline">
            <!-- Left Column -->
            <div class="column is-6-desktop is-12-tablet is-12-mobile">
              <!-- Customer Number  -->
              <div class="columns is-mobile">
                <div class="column">
                  <p class="subtitle is-6">
                    {{ $t("customer.detail.customer_number") }}:
                    {{ customerDetail.customer.customer_number }}
                  </p>
                </div>
              </div>

              <!-- Contact Number -->
              <div class="columns is-mobile">
                <div class="column is-7">
                  <p class="subtitle is-6">
                    {{ $t("customer.detail.contact_number") }}:
                    {{ customerDetail.customer.contact_number }}
                  </p>
                </div>
                <div
                  v-if="userProfile.roles.customer_update"
                  class="column is-1"
                >
                  <div class="hoverable" @click="showEditContactNumberForm">
                    <b-icon type="is-primary" icon="border-color" />
                  </div>
                </div>
              </div>

              <!-- IMEI Number + Edit Button -->
              <div class="columns is-mobile">
                <div class="column is-7">
                  <p class="subtitle is-6">
                    {{ $t("customer.detail.imei") }}:
                    {{ customerDetail.customer.imei }}
                  </p>
                </div>

                <div
                  v-if="userProfile.roles.customer_update"
                  class="column is-1"
                >
                  <div class="hoverable" @click="showEditCustomerForm('imei')">
                    <b-icon type="is-primary" icon="border-color" />
                  </div>
                </div>
              </div>

              <!-- Serial Number ( ESN )  -->
              <div class="columns is-mobile">
                <div class="column">
                  <p class="subtitle is-6">
                    {{ $t("customer.detail.esn") }}:
                    {{ customerDetail.customer.esn }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Right Column -->
            <div class="column is-6-desktop is-12-tablet is-12-mobile">
              <!-- Package Code  -->
              <div class="columns is-mobile">
                <div class="column">
                  <p class="subtitle is-6">
                    {{ $t("customer.detail.package_code") }}:
                    {{
                      customerDetail.customer.package_code
                        ? customerDetail.customer.package_code
                        : "-"
                    }}
                  </p>
                </div>
              </div>
              <!-- Site Prefix  -->
              <div class="columns is-mobile">
                <div class="column">
                  <p class="subtitle is-6">
                    {{ $t("customer.detail.site_prefix") }}:
                    {{
                      customerDetail.customer.location.site_prefix
                        ? customerDetail.customer.location.site_prefix
                        : "-"
                    }}
                  </p>
                </div>
              </div>

              <!-- Lock Distance + Edit Button -->
              <div class="columns is-mobile">
                <div class="column is-7">
                  <p class="subtitle is-6">
                    {{ $t("customer.detail.distance") }}:
                    {{
                      customerDetail.customer.location.lock_distance
                        | todecimal(2)
                    }}
                  </p>
                </div>
                <div
                  v-if="userProfile.roles.customer_distance"
                  class="column is-1"
                >
                  <div
                    class="hoverable"
                    @click="showEditCustomerForm('distance')"
                  >
                    <b-icon type="is-primary" icon="border-color" />
                  </div>
                </div>
              </div>

              <!-- Location (lat , lng) + Edit Button  -->
              <div class="columns is-mobile">
                <div class="column is-7">
                  <p class="subtitle is-6">
                    {{ $t("customer.detail.location") }}:
                    {{
                      customerDetail.customer.location.latitude | todecimal(6)
                    }}
                    ,
                    {{
                      customerDetail.customer.location.longitude | todecimal(6)
                    }}
                  </p>
                </div>
                <div
                  v-if="userProfile.roles.customer_update"
                  class="column is-1"
                >
                  <div
                    class="hoverable"
                    @click="
                      showEditLocationForm(
                        customerDetail.customer._id,
                        'service'
                      )
                    "
                  >
                    <b-icon type="is-primary" icon="border-color" />
                  </div>
                </div>

                <div
                  v-if="userProfile.roles.customer_distance"
                  class="column is-1"
                >
                  <div
                    class="hoverable"
                    @click="
                      showEditLocationForm(customerDetail.customer._id, 'site')
                    "
                  >
                    <b-icon type="is-primary" icon="earth" />
                  </div>
                </div>
              </div>
            </div>

            <!-- Fotter Column -->
            <div class="column is-12-desktop is-12-tablet is-12-mobile">
              <p
                v-if="
                  customerDetail.customer &&
                    customerDetail.customer.register_date
                "
                class="subtitle is-6"
              >
                {{ $t("customer.detail.register_date") }}:
                {{ customerDetail.customer.register_date | dateformatter }}
              </p>
              <!-- BUTTON : Cancel Registration  -->
              <div v-if="true" class="columns has-text-centered is-mobile">
                <div class="column">
                  <b-button
                    v-if="
                      this.customerDetail.customer.status === 'preactive' &&
                        this.userProfile.roles.customer_distance
                    "
                    class="dtac-font"
                    type="is-danger"
                    outlined
                    @click="showRollbackCustomerForm()"
                  >
                    {{ $t("customer.detail.unregister") }}:</b-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- PCRF INFO. -->
      <div class="tile is-4 is-vertical is-parent">
        <!-- PCRF COUNT INFO. -->
        <div class="tile is-child box">
          <p class="title is-4" style="margin-bottom: 0.25rem;">
            {{ $t("customer.detail.pcrf.count") }}
          </p>
          <p class="title is-1">{{ customerDetail.customer.pcrf_count }}</p>
          <p class="subtitle is-6">
            {{ $t("customer.detail.pcrf.last_active") }}:
            {{ customerDetail.customer.last_activity | dateformatter }}
          </p>
        </div>
        <!-- PCRF QUERY INFO. -->
        <div v-if="customerDetail.pcrf" class="tile is-child box">
          <p class="title is-4">
            {{ $t("customer.detail.pcrf_status") }}
            <b-tag v-if="!customerDetail.pcrf.limit" type="is-success"
              >NON-FUP</b-tag
            >
            <b-tag v-else type="is-danger">FUP</b-tag>
          </p>
          <p v-if="customerDetail.pcrf.timestamp" class="subtitle is-6">
            {{ $t("customer.detail.pcrf.last_active") }}:
            {{ customerDetail.pcrf.timestamp | dateformatter }}
          </p>
          <div v-if="customerDetail.pcrf.code">
            <p class="subtitle is-6" style="line-height: 1.8rem;">
              Error Code: {{ customerDetail.pcrf.code }}
              <br />
              {{ customerDetail.pcrf.description }}
            </p>
          </div>
          <div v-else>
            <p
              class="subtitle is-6"
              style="line-height: 1.8rem; margin-bottom: 0.75rem;"
            >
              {{ $t("customer.detail.msisdn") }}:
              {{ customerDetail.pcrf.msisdn }}
              <br />
              {{ $t("customer.detail.imei") }}: {{ customerDetail.pcrf.imei }}
            </p>
          </div>
          <b-button
            type="is-primary"
            outlined
            @click="resetPcrfStatus"
            :disabled="userProfile.roles && !userProfile.roles.customer_update"
            >Reset PCRF</b-button
          >
        </div>
        <div v-else class="tile is-child box">
          <p class="title is-4">
            Cannot Connect PCRF
          </p>
        </div>
      </div>
    </div>

    <b-tabs @change="didTabSelected">
      <!-- retry_queue -->
      <b-tab-item>
        <template slot="header">
          <span>
            {{ $t("customer.tabs.title.retry_queue") }}
            <b-tag
              v-if="customerDetail.badge.retry_queue > 0"
              rounded
              type="is-danger"
              >{{ customerDetail.badge.retry_queue }}</b-tag
            >
          </span>
        </template>
        <retry-queue-table :customer_id="customerId" :enable="true" />
      </b-tab-item>
      <!-- customer_history -->
      <b-tab-item>
        <template slot="header">
          <span>
            {{ $t("customer.tabs.title.customer_history") }}
            <b-tag v-if="customerDetail.badge.history > 0" rounded>{{
              customerDetail.badge.history
            }}</b-tag>
          </span>
        </template>
        <dah-history-table
          :customer_id="customerId"
          :enable="isShowDahHistory"
        />
      </b-tab-item>
      <!-- pcrf_history -->
      <b-tab-item :label="$t('customer.tabs.title.pcrf_history')">
        <template slot="header">
          <span>
            {{ $t("customer.tabs.title.pcrf_history") }}
            <b-tag v-if="customerDetail.badge.pcrf_history > 0" rounded>{{
              customerDetail.badge.pcrf_history
            }}</b-tag>
          </span>
        </template>
        <pcrf-history-table
          :customer_id="customerId"
          :enable="isShowPcrfHistory"
        />
      </b-tab-item>
      <!-- Customer Location -->
      <b-tab-item
        :label="$t('customer.tabs.title.home_location')"
        :visible="userProfile.roles.map_area"
      >
        <customer-site-map
          :customer_id="customerId"
          :reload="isReloadSiteMap"
          :enable="isShowSiteLocation"
          @completed_reload="isReloadSiteMap = false"
        />
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapState } from "vuex";
import AlertManager from "@/managers/AlertManager";
import CustomerApiManager from "@/apis/CustomerApiManager";
import CustomerSiteMap from "@/components/maps/CustomerSiteMap.vue";
import DahHistoryTable from "@/components/tables/DahHistoryTable.vue";
import RetryQueueTable from "@/components/tables/RetryQueueTable.vue";
import PcrfHistoryTable from "@/components/tables/PcrfHistoryTable.vue";
import EditCustomerForm from "@/components/forms/EditCustomerForm.vue";
import EditLocationForm from "@/components/forms/EditLocationForm.vue";
import EditContactNumberForm from "@/components/forms/EditContactNumberForm.vue";

export default {
  name: "CustomerDetail",
  components: {
    CustomerSiteMap,
    DahHistoryTable,
    RetryQueueTable,
    PcrfHistoryTable
  },
  props: ["msisdn"],
  data() {
    return {
      activeTab: 0,
      customerId: null,
      customerDetail: null,
      isReloadSiteMap: false,
      isShowRetryQueue: true,
      isShowDahHistory: false,
      isShowPcrfHistory: false,
      isShowSiteLocation: false
    };
  },
  computed: mapState(["userProfile"]),
  watch: {
    msisdn: function(val) {
      this.getCustomerDetail(val);
    }
  },
  filters: {
    capitalized: function(value) {
      if (!value) return "";
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    uppercased: function(value) {
      if (!value) return "";
      return value.toUpperCase();
    },
    todecimal: function(value, decimal_place) {
      if (!value) return "";
      return Number(value).toFixed(decimal_place);
    },
    dateformatter: function(value) {
      if (!value) return "";
      return dayjs(value).format("DD/MM/YYYY @ HH:mm");
    }
  },
  methods: {
    resetPcrfStatus: async function() {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const result = await CustomerApiManager.requestResetPcrfStatus(
        this.customerId
      );
      loadingComponent.close();

      switch (result.code) {
        case "0":
          AlertManager.showSuccessSnackbar("Reset PCRF Successfully");
          this.reloadCustomerDetailComp();
          break;

        default:
          AlertManager.showErrorSnackbar(result.message);
          break;
      }
    },
    rollbackCustomerRegistration: async function() {
      this.$emit("on_rollback");
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });

      const result = await CustomerApiManager.requestCustomerRollback(
        this.customerDetail.customer.msisdn,
        this.customerDetail.customer.contact_number
      );
      loadingComponent.close();

      switch (result.code) {
        case "0":
          AlertManager.showSuccessSnackbar("Rollback Customer Successfully");
          this.$emit("on_rollback");
          break;

        default:
          AlertManager.showErrorSnackbar(result.message);
          break;
      }
    },
    getCustomerDetail: async function(msisdn) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const detailResult = await CustomerApiManager.requestCustomerDetail(
        msisdn
      );
      loadingComponent.close();

      switch (detailResult.code) {
        case "0":
          this.customerDetail = detailResult.data;
          this.customerId = detailResult.data.customer._id;
          break;

        default:
          AlertManager.showErrorSnackbar(detailResult.message);
          break;
      }
    },
    didTabSelected: function(index) {
      switch (index) {
        case 1:
          this.isShowDahHistory = true;
          break;

        case 2:
          this.isShowPcrfHistory = true;
          break;

        case 3:
          this.isShowSiteLocation = true;
          break;

        default:
          this.isShowRetryQueue = true;
          break;
      }
    },
    showEditCustomerForm: function(field) {
      switch (field) {
        case "imei":
          this.$buefy.modal.open({
            parent: this,
            hasModalCard: true,
            component: EditCustomerForm,
            props: {
              field,
              value: this.customerDetail.customer.imei
            },
            events: {
              update_customer_detail: () => {
                this.reloadCustomerDetailComp();
              }
            }
          });
          break;

        case "distance":
          this.$buefy.modal.open({
            parent: this,
            hasModalCard: true,
            component: EditCustomerForm,
            props: {
              field,
              value: this.customerDetail.customer.location.lock_distance
            },
            events: {
              update_customer_detail: () => {
                this.reloadCustomerDetailComp();
              }
            }
          });
          break;
        default:
          break;
      }
    },
    showEditLocationForm: function(customerId, editType) {
      this.$buefy.modal.open({
        parent: this,
        hasModalCard: true,
        component: EditLocationForm,
        props: {
          editType,
          customerId
        },
        events: {
          update_customer_detail: () => {
            this.reloadCustomerDetailComp();
          }
        }
      });
    },
    showEditContactNumberForm: function() {
      this.$buefy.modal.open({
        parent: this,
        hasModalCard: true,
        component: EditContactNumberForm,
        props: {
          type: "customer",
          currentContact: this.customerDetail.customer.contact_number
        },
        events: {
          update_customer_contact: () => {
            this.reloadCustomerDetailComp();
          }
        }
      });
    },
    showRollbackCustomerForm: function() {
      if (
        this.customerDetail.customer.status === "preactive" &&
        this.userProfile.roles.customer_distance
      ) {
        this.$buefy.dialog.confirm({
          title: this.$t("customer.unregister_popup.title"),
          message:
            this.$t("customer.unregister_popup.description") +
            "<b>" +
            this.customerDetail.customer.msisdn +
            "</b>",
          confirmText: this.$t("customer.unregister_popup.confirm"),
          cancelText: this.$t("customer.unregister_popup.cancel"),
          type: "is-danger",
          hasIcon: true,
          onConfirm: () => this.rollbackCustomerRegistration()
        });
      }
    },
    reloadCustomerDetailComp: function() {
      this.isReloadSiteMap = true;
      this.getCustomerDetail(this.customerId);
    }
  },
  mounted() {
    this.customerId = this.$route.params.id;
    this.getCustomerDetail(this.customerId);
  }
};
</script>

<style scoped>
.hoverable {
  cursor: pointer;
}
</style>
